var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconList = function SvgIconList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 0
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Custom-Preset",
    stroke: "#979797",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4.058,
    y1: 7.129,
    x2: 5.881,
    y2: 7.129,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.993,
    y1: 7.129,
    x2: 27.941,
    y2: 7.129,
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.058,
    y1: 16.129,
    x2: 5.881,
    y2: 16.129,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.993,
    y1: 16.129,
    x2: 27.941,
    y2: 16.129,
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.058,
    y1: 25.129,
    x2: 5.881,
    y2: 25.129,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.993,
    y1: 25.129,
    x2: 27.941,
    y2: 25.129,
    id: "Path-2"
  })))));
};
export { SvgIconList as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlLXdpZHRoPSIwIj4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJDdXN0b20tUHJlc2V0IiBzdHJva2U9IiM5Nzk3OTciIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxsaW5lIHgxPSI0LjA1Nzg4ODU5IiB5MT0iNy4xMjg1NjI5MiIgeDI9IjUuODgxMzIyOSIgeTI9IjcuMTI4NTYyOTIiIGlkPSJQYXRoIj48L2xpbmU+CiAgICAgICAgICAgIDxsaW5lIHgxPSI3Ljk5MjgwMjM0IiB5MT0iNy4xMjg1NjI5MiIgeDI9IjI3Ljk0MTM2NTIiIHkyPSI3LjEyODU2MjkyIiBpZD0iUGF0aC0yIj48L2xpbmU+CiAgICAgICAgICAgIDxsaW5lIHgxPSI0LjA1Nzg4ODU5IiB5MT0iMTYuMTI4NTYyOSIgeDI9IjUuODgxMzIyOSIgeTI9IjE2LjEyODU2MjkiIGlkPSJQYXRoIj48L2xpbmU+CiAgICAgICAgICAgIDxsaW5lIHgxPSI3Ljk5MjgwMjM0IiB5MT0iMTYuMTI4NTYyOSIgeDI9IjI3Ljk0MTM2NTIiIHkyPSIxNi4xMjg1NjI5IiBpZD0iUGF0aC0yIj48L2xpbmU+CiAgICAgICAgICAgIDxsaW5lIHgxPSI0LjA1Nzg4ODU5IiB5MT0iMjUuMTI4NTYyOSIgeDI9IjUuODgxMzIyOSIgeTI9IjI1LjEyODU2MjkiIGlkPSJQYXRoIj48L2xpbmU+CiAgICAgICAgICAgIDxsaW5lIHgxPSI3Ljk5MjgwMjM0IiB5MT0iMjUuMTI4NTYyOSIgeDI9IjI3Ljk0MTM2NTIiIHkyPSIyNS4xMjg1NjI5IiBpZD0iUGF0aC0yIj48L2xpbmU+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";